import { UploadOutlined } from '@ant-design/icons';
import { Upload, message } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { useCustomUpload } from 'hooks/business/useUploadResource';
import { useTranslate } from '@tolgee/react';

interface RefuseUploadImageProps {
  value?: any;
  onChange?: (value: any) => void;
  accepts?: string[];
  countLimit: number;
  sizeLimit: number;
  internalStoreId: string;
  reqSource: string;
}

export const RefuseUploadImage = (props: RefuseUploadImageProps) => {
  const {
    value = [],
    accepts = ['jpg', 'jpeg', 'png'],
    countLimit,
    sizeLimit,
    internalStoreId,
    reqSource,
    onChange,
  } = props;
  const { t } = useTranslate();
  const customUpload = useCustomUpload();

  return (
    <div>
      <Upload
        listType="picture-card"
        accept={accepts.map((_) => `.${_}`).join(',')}
        fileList={value}
        onChange={({ fileList }) => onChange?.(fileList)}
        beforeUpload={(file) => {
          if (file.size > sizeLimit * 1024 * 1024) {
            message.warn(`${sizeLimit}M`);

            return Upload.LIST_IGNORE;
          }

          return Promise.resolve(file);
        }}
        customRequest={(props) =>
          customUpload(props, {
            storeId: internalStoreId,
            fileType: 'IMAGE',
            reqSource,
          })
        }
      >
        {(value?.length ?? 0) < countLimit && (
          <div>
            <UploadOutlined />
            <div>{t('phrase.上传图片')}</div>
          </div>
        )}
      </Upload>
      <div className="text-xs text-[var(--fett-text-tertiary)]">
        {t('ViewRefund.refuseUploadImageTips', {
          x: countLimit,
          y: sizeLimit,
          z: accepts.map((_) => _.toUpperCase()).join('/'),
        })}
      </div>
    </div>
  );
};

export const useRefuseUploadImageValidate = (optional = false) => {
  const { t } = useTranslate();

  return (fileList: UploadFile<any>[]) => {
    if (!optional && (!fileList || fileList.length === 0)) {
      return t('phrase.请上传图片');
    }

    if (fileList && fileList.some(({ status }) => status !== 'success' && status !== 'done')) {
      return t('phrase.存在未上传成功的图片/视频，请删除后重新上传', {
        text: t('phrase.typeImage'),
      });
    }

    return undefined;
  };
};
